"use client";

import { cn } from "@/lib/utils";
import {
  CREATOR_SOURCE_CONFIG,
  ESTIMATE_EARNINGS_MORE_SOURCE_IDS,
  type OnboardingCreatorSource,
} from "../config/creatorSources";

export interface EstimateEarningsMoreIconProps {
  className?: string;
  sourceIds?: readonly OnboardingCreatorSource[];
}

const MORE_ICON_COLOR_CLASSES: Record<OnboardingCreatorSource, string> = {
  substack: "text-[#FE4800]",
  beehiiv: "text-black",
  medium: "text-black",
  website: "text-[#2EB67D]",
  linkedin: "text-[#0A66C2]",
  instagram: "text-[#E4405F]",
  tiktok: "text-black",
  youtube: "text-[#FF0000]",
};

export function EstimateEarningsMoreIcon({
  className,
  sourceIds = ESTIMATE_EARNINGS_MORE_SOURCE_IDS,
}: EstimateEarningsMoreIconProps) {
  return (
    <div
      className={cn("flex items-center justify-center -space-x-1", className)}
      aria-hidden="true"
    >
      {sourceIds.map((sourceId, index) => {
        const config = CREATOR_SOURCE_CONFIG[sourceId];
        if (!config) return null;
        const Icon = config.estimateIcon;
        const colorClass = MORE_ICON_COLOR_CLASSES[sourceId] ?? "text-[#475467]";

        return (
          <span
            key={sourceId}
            data-testid={`more-icon-${sourceId}`}
            className={cn(
              "size-6 shrink-0 items-center justify-center rounded-full border border-[#D0D5DD] bg-white ring-2 ring-white shadow-xs",
              index >= 2 ? "hidden md:flex" : "flex"
            )}
          >
            <Icon className={cn("size-3.5 shrink-0", colorClass)} />
          </span>
        );
      })}
      <span
        data-testid="more-icon-overflow-count"
        className="flex md:hidden size-6 shrink-0 items-center justify-center rounded-full border border-[#D0D5DD] bg-[#F2F4F7] ring-2 ring-white shadow-xs text-[10px] font-semibold text-[#344054]"
      >
        +2
      </span>
    </div>
  );
}
